import { render, staticRenderFns } from "./referrals-tab-panel.vue?vue&type=template&id=3321e62d&scoped=true&"
import script from "./referrals-tab-panel.vue?vue&type=script&lang=js&"
export * from "./referrals-tab-panel.vue?vue&type=script&lang=js&"
import style0 from "./referrals-tab-panel.vue?vue&type=style&index=0&id=3321e62d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3321e62d",
  null
  
)

export default component.exports